import { DataTable, TableProvider, Grid, Skeleton } from '@cxc/react-fpds-components';
import IncentiveTableColumnConstants from '../../constants/TableColumnConstants';
import styles from './SkeletonTable.module.scss';
import { useEffect, useState } from 'react';

const SkeletonTable = ({ numberOfRows }: any) => {
    const numberOfColumns = IncentiveTableColumnConstants.length;
    const [skeletonRows, setSkeletonRows] = useState([]);

    useEffect(() => {
        const skeletons: any = [];
        const cellData: any = [];
        Array.from(Array(numberOfColumns)).forEach(() => {
            cellData.push({
                leadingComponents: <Skeleton data-testid="skeleton" height={14} width={192} />,
            });
        });
        Array.from(Array(numberOfRows)).forEach((index) => {
            skeletons.push({
                rowsId: index,
                cellData: cellData,
            });
        });
        setSkeletonRows(skeletons);
    }, [numberOfColumns, numberOfRows]);

    return (
        <Grid>
            <Grid.Item className={styles.container} xl={12} l={12} m={12} s={12}>
                <TableProvider>
                    <DataTable
                        isCheckboxEnabled={false}
                        isOptionProps={{ isOptionsEnabled: false }}
                        isStickyColumnEnabled={false}
                        className={styles.container}
                        headerValues={IncentiveTableColumnConstants}
                        rowValues={skeletonRows}
                    />
                </TableProvider>
            </Grid.Item>
        </Grid>
    );
};

export default SkeletonTable;
